import React from 'react'

function GenericThreeColTableWithColors({
  firstHeading,
  secondHeading,
  thirdHeading,
  holdings,
}) {
  return (
    <table className="js-data-table Table Table--reversed Table--striped">
      <thead className="Table-head">
        <tr className="Table-row">
          <th className="Table-header u-alignMiddle tableHeader" colSpan="2">
            {firstHeading}
          </th>
          <th className="Table-header u-alignMiddle u-textRight tableHeader">
            {secondHeading}
          </th>
          {thirdHeading && (
            <th className="Table-header u-alignMiddle u-textRight tableHeader">
              {thirdHeading}
            </th>
          )}
        </tr>
      </thead>
      <tbody className="Table-body">
        {holdings.map((holdingItem, index) => {
          const { color, holdingName, holdingValue, holdingValue2 } =
            holdingItem

          return (
            <tr className="Table-row" key={`hgx${holdingName}${index}`}>
              <td className="Table-cell u-paddingRight0 Table-cell--fixed-width--5gu">
                {color && (
                  <hr
                    aria-hidden="true"
                    className="Bullet"
                    role="presentation"
                    style={{ color: color }}
                  />
                )}
              </td>
              <td className="Table-cell u-paddingLeft2gu">{holdingName}</td>
              <td className="Table-cell u-textRight">{holdingValue}</td>
              {holdingValue2 && (
                <td className="Table-cell u-textRight">{holdingValue2}</td>
              )}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
export default GenericThreeColTableWithColors
